import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import drilldown from 'highcharts/modules/drilldown';

import Chart from './Chart';
import helpers from '../../utils/helpers';
import { numberToHumanChart } from '../../utils/formatter';

if (!Highcharts.Chart.prototype.addSeriesAsDrilldown) {
  drilldown(Highcharts);
}

class ColumnDrilldownChart extends Component {
  static propTypes = {
    chartId: PropTypes.string.isRequired,
    series: PropTypes.arrayOf(
      PropTypes.shape({
        y: PropTypes.number.isRequired,
        ref_no: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string.isRequired,
        data: PropTypes.arrayOf(
          PropTypes.array.isRequired,
        ).isRequired,
      }).isRequired,
    ),
    selectedSeries: PropTypes.object.isRequired,
    name: PropTypes.string,
    config: PropTypes.object,
    style: PropTypes.object,
  };
  static defaultProps = {
    config: {},
  }
  seriesName = (name, store) => {
    if (store) { return `${name} (${helpers.shortStoreNames[store]})`; }
    return name;
  }
  series = () => {
    const { series, selectedSeries, name } = this.props;
    return [{
      name,
      colorByPoint: true,
      data: series.filter(s => selectedSeries[s.ref_no].visible).map(s => ({
        name: this.seriesName(s.name, selectedSeries[s.ref_no].store),
        y: s.y,
        color: selectedSeries[s.ref_no].color,
        drilldown: s.drilldown,
      })),
    }];
  };
  drilldownSeries = () => this.props.series.filter(
    s => this.props.selectedSeries[s.ref_no].visible,
  ).map(s => ({
    name: s.name,
    id: s.drilldown,
    data: s.data,
  }));
  config = (props = this.props) => ({
    chart: {
      type: 'column',
    },
    title: {
      text: null,
    },
    subtitle: {
      text: null,
    },
    xAxis: {
      crosshair: false,
      type: 'category',
      tickmarkPlacement: 'on',
      labels: {
        style: {
          color: '#848ea1',
        },
        formatter() {
          if (this.chart.series[0].name === props.name) {
            return this.chart.series[0].userOptions.data[this.pos].name;
          }
          return this.value;
        },
      },
    },
    yAxis: {
      gridLineWidth: 1,
      gridLineColor: '#edf0f5',
      title: {
        text: null,
      },
      labels: {
        formatter() {
          return `$${numberToHumanChart(this.value)}`;
        },
      },
      min: 0,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '${point.y:.2f}',
          color: '#555f77',
        },
      },
    },
    tooltip: {
      formatter() {
        const rows = this.points
          .map((point) => {
            const { name } = point.series.userOptions;
            return `
                <tr>
                  <td class="text-xxs-left p-l-0 p-b-0">
                    <span style="color:${point.series.color};">\u25CF</span>
                    ${name === props.name ? point.key : name}
                  </td>
                  <td class="text-xxs-right p-r-0 p-b-0">
                    <b>$${numberToHumanChart(point.y)}</b>
                  </td>
                </tr>
              `;
          })
          .join('');
        return `
            <div class="p-xs">
              <table class="table">
                ${rows}
              </table>
            </div>
          `;
      },
    },
    series: this.series(),
    drilldown: {
      series: this.drilldownSeries(),
      activeAxisLabelStyle: {
        textDecoration: 'none',
        color: '#2679ff',
      },
      activeDataLabelStyle: {
        textDecoration: 'none',
        color: '#2679ff',
      },
      drillUpButton: {
        relativeTo: 'spacingBox',
        position: {
          y: -30,
          x: 0,
        },
        theme: {
          fill: 'white',
          'stroke-width': 1,
          stroke: '#ced2db',
          r: 4,
          states: {
            hover: {
              fill: 'white',
              stroke: '#acb4c2',
            },
            select: {
              fill: 'white',
              stroke: '#acb4c2',
            },
          },
        },
      },
    },
    ...this.props.config,
    lang: {
      noData: '<h2 class="text-lg m-b">No data to display</h2>',
    },
  })
  render() {
    return (
      <Chart
        config={this.config()}
        immutable
        chartId={this.props.chartId}
        ref={(chart) => {
          this.chart = chart;
        }}
        className="column-drilldown-chart show-overflow"
        style={this.props.style}
      />
    );
  }
}

export default ColumnDrilldownChart;
